import type { SnakeCasedPropertiesDeep } from 'type-fest';

import type { SearchRequestType, SearchResultType, SimilarLoadsResponseType } from 'api/search/types';
import { PopularDestinationsRequest } from 'types/cargosApp/Requests';

import axios from '../axios';

const SIMILAR_LOADS_DEFAULT_TAKE = 10;

function getLoads(data: SnakeCasedPropertiesDeep<SearchRequestType>) {
  return axios.post('/webapi/public/v1.0/loads/search', data);
}

function getSimilarLoadsByMainLoadId(
  mainLoadId: string,
  encodedSearchContext: string,
  pagination: { take?: number; skip?: number; excludedCargoApplicationIds?: string[] } = {},
) {
  return axios.post<SnakeCasedPropertiesDeep<SimilarLoadsResponseType>>(
    `/gw/search_loads/web/v1/loads/${mainLoadId}/similar`,
    {
      encoded_search_context: encodedSearchContext,
      take: pagination.take ?? SIMILAR_LOADS_DEFAULT_TAKE,
      skip: pagination.skip ?? 0,
      excluded_cargo_application_ids: pagination.excludedCargoApplicationIds ?? [],
    },
  );
}

function getLoadsByIds(ids: string[]) {
  return axios.post<SearchResultType>('webapi/v1.0/loads/search-by-ids/old', ids);
}

function getPopularDestinations(data: PopularDestinationsRequest) {
  return axios.post('/webapi/public/v1.0/loads/seo/popular-destinations', data || {});
}

function hideLoads(loads: string[]) {
  return axios.post('/webapi/loads/search/hidden_loads', loads);
}

function showLoads() {
  const data = {
    delete_firms: true,
    delete_loads: true,
  };
  return axios.delete('/webapi/loads/search/hidden', { data });
}

export { getLoads, getLoadsByIds, getPopularDestinations, getSimilarLoadsByMainLoadId, hideLoads, showLoads };
